import React from 'react';
import { Image } from 'react-bootstrap';
import lekeTedavisi from '../../images/home/taniTedavi/16001738625587.jpg';
import '../../styles/about.css';

const TaniTedavi12 = () => {
    return (
        <div>
            <h5 className='main-title'>DOLGU NEDİR, NİÇİN UYGULANIR?</h5>
            <hr />


            <p>Modern tıptaki gelişmeler sonucu yaşam sürelerinin giderek uzaması, kişilerin daha sağlıklı ve güzel görünme isteklerini ön plana çıkarmıştır. Yaşlanmanın bir göstergesi de kırışıklıklar ve sarkma olduğundan, bunları yok etmeye yönelik uygulamalar giderek önem kazanmaktadır. Dolgu uygulamalarının, cerrahi uygulamalara göre daha ekonomik ve muayenehanede uygulanabilir olması, uygulama sonrası bakım gerektirmemesi, iş ve sosyal yaşamdan uzak kalınmaması ve yan etkilerinin minimal olması nedeniyle sık tercih edilir olmuştur.</p>

            <p>Hiyaluronik asit en sık kullanılan dolgu maddesidir ve bakteri kültürü sonucu elde edilir.</p>

            <p>Yaşlanma ile birlikte deride elastik lif, kollajen lif, yağ tabakası ve hiyaluronik asit azalmasına bağlı olarak kırışıklıklar ve sarkmalar oluşur. Hiyaluronik asit, güçlü su tutucu etkisiyle hem deriye nem verir, hem de elastik ve kollajen liflerin yapımını artırır. Böylece cildin yenilenmesine ve daha genç görünmesine katkıda bulunur.</p>

            <p><strong>Dolgu maddeleri;</strong></p>
            <ul>
                <li>Yüzün her bölgesindeki çizgi ve hacim kayıplarında,</li>
                <li>Yanak ve elmacık kemiği bölgelerinin belirginleştirilmesinde,</li>
                <li>Dudakların biçimlendirilip dolgunlaştırılmasında,</li>
                <li>Burun kusurlarının düzeltilmesinde,</li>
                <li>Sivilce ve yara izlerinin giderilmesinde,</li>
                <li>Kaşa ve kulak memesine şekil verilmesinde,</li>
                <li>Göz altı çökmelerini azaltmak için sıklıkla kullanılırlar.</li>
            </ul>
            <Image src={lekeTedavisi} fluid className='mb-4' style={{ width: '70%' }} />

            <p>Ayrıca boyun ve dekolte bölgesi kırışıklıklarında, ellerin gençleştirilmesinde de tercih edilirler.</p>

            <p>Dolgu maddeleri 1-3 yıl arasında etkinliğini sürdürür. Vücut tarafından zaman içinde emilerek kaybolur. Fakat elastik ve kollajen lifleri uyarıp çoğalttıkları için dolgu maddesi tamamen emildiğinde bile cilt daha iyi görünür.</p>

            <p>Her bölgeye uygulanan dolgu yoğunluğu ve miktarı farklıdır. Dolgu uygulamaları etkin ve güvenilir olmakla birlikte, uzman kişiler tarafından uygun ortamda, uygun kişilere, uygun dozlarda yapılmalıdır. Gebelerde, emziren kadınlarda, otoimmün hastalığı olanlarda, kan sulandırıcı kullananlarda ve gerçek üstü beklentisi olanlarda (dismorfobik bozukluk) uygulanmamalıdır.</p>
        </div>

    );
};

export default TaniTedavi12;
